export default "/images/vendor/flag-icon-css/flags/4x3/bb.svg?021629a6a596929b04629ceed2c33ef4";